import { createSelector } from '@reduxjs/toolkit';
import { Store } from 'components/common/types/Store.types';

export const getCurrentLine = createSelector(
  (state: Store) => state.dealManagement.commonDeal.currentLine,
  (currentLine) => currentLine,
);
